export default {
  FF91SNA: {
    fullModelCode: 'FF91SNA',
    name: 'FF 91 2.0',
    referralPoints: '100,000',
  },
  FF91Futurist: {
    fullModelCode: 'FF91FNA',
    name: 'FF 91 2.0 Futurist',
    referralPoints: '125,000 ',
  },
  FF91FuturistAlliance: {
    fullModelCode: 'FF91FNA-ALLIANCE',
    name: 'FF 91 2.0 Futurist Alliance',
    referralPoints: '154,500',
  },
}
